/**
 * Local development configuration.
 *
 * Copy local.dev.config.example.ts to local.dev.config.ts and customize.
 * local.dev.config.ts is gitignored — it never gets committed.
 */

export interface ILocalDevConfig {
    /** Proxy gateway requests to a custom URL (e.g., 'https://localhost:8443') */
    gatewayProxyUrl?: string,

    /** Override tool URLs for local development. Key = assetId or displayName, value = URL */
    toolOverrides?: Record<string, string>,

    /** Enable verbose debug logging for sidebar tool visibility, store tags, etc. */
    enableDevLogs?: boolean,

    /** P414214415: Simulate no-store-access in store selection for testing */
    simulateNoStores?: boolean,

    /** Force AppConfig feature flags on or off locally, bypassing the Gateway. Key = registered flag name. */
    featureFlagOverrides?: Record<string, boolean>,
}

const LOCAL_HOSTNAMES = ['localhost.aka.corp.amazon.com', '10.0.2.2']

function isLocalDev (): boolean {
    try {
        return LOCAL_HOSTNAMES.includes(window.location.hostname)
    } catch {
        return false
    }
}

let config: ILocalDevConfig = {}

if (isLocalDev()) {
    try {
        // tslint:disable-next-line: no-var-requires
        config = require('./local.dev.config').default || require('./local.dev.config')
    } catch {
        // No local config — use defaults
    }
}

export function getLocalDevConfig (): ILocalDevConfig {
    return config
}

/**
 * Log only when enableDevLogs is set in local.dev.config.ts.
 * Stripped in production builds (webpack dead code elimination via isLocalDev check).
 */
export function devLog (...args: any[]): void {
    if (config.enableDevLogs) {
        console.log('[DEBUG SMP]', ...args)
    }
}
